import { useState } from 'react';

import { useHistory } from 'react-router-dom';

import { IdentityWizardLayout } from '@identity/presentation/components/base';
import { PROFILE_ROUTE } from '@identity/presentation/constants';

import { ChangePasswordView } from './ChangePasswordView';
import { PasswordChangedScreen } from './PasswordChangedScreen';

/**
 * The in-session password change: write it, then confirm.
 *
 * It reads no requirement map. This screen always sends both passwords because its design always
 * asks for both, so there is nothing to derive; and there is nothing to resume either, since both
 * fields are secrets a reload is right to forget.
 */
export const ChangePasswordWizard = () => {
  const history = useHistory();
  const [isDone, setIsDone] = useState(false);

  return (
    <IdentityWizardLayout>
      {isDone ? (
        <PasswordChangedScreen />
      ) : (
        <ChangePasswordView onCancel={() => history.replace(PROFILE_ROUTE)} onChanged={() => setIsDone(true)} />
      )}
    </IdentityWizardLayout>
  );
};
